import { createContext } from 'react'

const OfferCarouselMarketingHeadlineContext = createContext(false)

export default OfferCarouselMarketingHeadlineContext
